<template>
    <section class="bottom-banner-container">
        <div id="bottom-banner" class="page-container">
            <div class="text-content">
                <div>
                    <h2 class="open-sans fw-bold">
                        Broad commercial and Medicaid coverage and a savings
                        program for eligible, commercially insured patients<sup
                            >1</sup
                        >
                    </h2>

                    <p class="fw-semibold">
                        If you need assistance finding a particular dosage
                        strength, call our Pharmacy Locator service at
                        1-877-938-4766, Monday-Friday 8
                        <span class="ampm">AM</span> to 9
                        <span class="ampm">PM</span> ET.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    methods: {},
};
</script>
<style scoped>
#bottom-banner {
    .ampm {
        font-size: 14px;
    }
}
</style>
